import {gql} from '@apollo/client'

export const GET_ALL_CONTACTS_API = gql`
  query GetAllContactsAPI(
    $offset: Int
    $first: Int
    $name: String
    $status: String
    $policyStatus: String
    $policyType: String
    $state: String
    $carrier: String
    $createdAfter: Date
    $createdBefore: Date
    $birthMonth: String
    $ageFrom: String
    $ageTo: String
    $medicareUnifiedFilter: String
    $turning65In3Months: Boolean
    $age64NotApproaching65: Boolean
    $tags: String
    $gender: String
    $preferredLanguage: String
    $immigrationStatus: String
    $zipCode: String
    $isPolicyHolder: Boolean
    $withoutPolicy: Boolean
    $withoutLead: Boolean
    $myContacts: Boolean
    $isImportant: Boolean
    $user: String
    $assignedTo: String
    $signatureForm: String
    $hasSignedEntry: Boolean
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $policyCreatedFrom: Date
    $policyCreatedTo: Date
    $submissionDateFrom: Date
    $submissionDateTo: Date
    $completedDateFrom: Date
    $completedDateTo: Date
    $lead: String
    $isRecipient: Boolean
    $segment: String
    $organization: String
    $effectiveYear: String
  ) {
    allContacts(
      offset: $offset
      first: $first
      name: $name
      status: $status
      policyStatus: $policyStatus
      policyType: $policyType
      state: $state
      carrier: $carrier
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      birthMonth: $birthMonth
      ageFrom: $ageFrom
      ageTo: $ageTo
      medicareUnifiedFilter: $medicareUnifiedFilter
      turning65In3Months: $turning65In3Months
      age64NotApproaching65: $age64NotApproaching65
      tags: $tags
      gender: $gender
      preferredLanguage: $preferredLanguage
      immigrationStatus: $immigrationStatus
      zipCode: $zipCode
      isPolicyHolder: $isPolicyHolder
      withoutPolicy: $withoutPolicy
      withoutLead: $withoutLead
      myContacts: $myContacts
      isImportant: $isImportant
      user: $user
      assignedTo: $assignedTo
      signatureForm: $signatureForm
      hasSignedEntry: $hasSignedEntry
      effectiveDateAfter: $effectiveDateAfter
      effectiveDateBefore: $effectiveDateBefore
      policyCreatedFrom: $policyCreatedFrom
      policyCreatedTo: $policyCreatedTo
      submissionDateFrom: $submissionDateFrom
      submissionDateTo: $submissionDateTo
      completedDateFrom: $completedDateFrom
      completedDateTo: $completedDateTo
      lead: $lead
      isRecipient: $isRecipient
      segment: $segment
      organization: $organization
      effectiveYear: $effectiveYear
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          fullName
          firstName
          lastName
          email
          phone
          dateBirth
          gender
          address1
          address2
          city
          zipCode
          created
          isImportant
          subscriptionStatus
          stateEU {
            id
            name
            code
          }
          tagAssignments {
            tag {
              id
              name
              color
            }
          }
          memberPolicy {
            id
            rol
            relationship
            firstName
            lastName
            phone
            relationship
            healthsherpaContactId
            healthsherpaSyncAt
            policy {
              id
              policyName
              status
              stateDocs
              paymentStatus
              type
              created
              effectiveDate
              completedDate
              applicants
              members
              memberId
              hasAutoPolicy
              hasHomePolicy
              agentOfRecord
              zipCode
              stateEU {
                id
                code
              }
              user {
                id
                firstName
                lastName
                email
                cellphone
                avatar
              }
              holderMember {
                id
                firstName
                lastName
                phone
                rol
                relationship
              }
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              assignedTo {
                id
                firstName
                lastName
              }
            }
          }
          lead {
            id
          }
          members {
            edges {
              node {
                id
                rol
                relationship
                firstName
                lastName
                phone
                relationship
                healthsherpaContactId
                healthsherpaSyncAt
                policy {
                  id
                  policyName
                  status
                  stateDocs
                  paymentStatus
                  type
                  created
                  effectiveDate
                  completedDate
                  applicants
                  members
                  memberId
                  hasAutoPolicy
                  hasHomePolicy
                  agentOfRecord
                  zipCode
                  stateEU {
                    id
                    code
                  }
                  user {
                    id
                    firstName
                    lastName
                    email
                    cellphone
                    avatar
                  }
                  holderMember {
                    id
                    firstName
                    lastName
                    phone
                    rol
                    relationship
                  }
                  carrier {
                    id
                    name
                  }
                  typePolicy {
                    id
                    typePolicy
                  }
                  assignedTo {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
          signatureEntries {
            edges {
              node {
                id
                signedOn
                requestedOn
                status
              }
            }
          }
        }
      }
    }
  }
`

export const GET_CONTACTS_PAGE_API = gql`
  query GetContactsPageAPI(
    $offset: Int
    $first: Int
    $name: String
    $status: String
    $policyStatus: String
    $policyType: String
    $state: String
    $carrier: String
    $createdAfter: Date
    $createdBefore: Date
    $birthMonth: String
    $ageFrom: String
    $ageTo: String
    $turning65In3Months: Boolean
    $age64NotApproaching65: Boolean
    $tags: String
    $gender: String
    $preferredLanguage: String
    $immigrationStatus: String
    $zipCode: String
    $isPolicyHolder: Boolean
    $withoutPolicy: Boolean
    $withoutLead: Boolean
    $myContacts: Boolean
    $isImportant: Boolean
    $user: String
    $assignedTo: String
    $signatureForm: String
    $hasSignedEntry: Boolean
    $effectiveDateAfter: Date
    $effectiveDateBefore: Date
    $policyCreatedFrom: Date
    $policyCreatedTo: Date
    $submissionDateFrom: Date
    $submissionDateTo: Date
    $completedDateFrom: Date
    $completedDateTo: Date
    $lead: String
    $isRecipient: Boolean
    $segment: String
    $organization: String
    $effectiveYear: String
  ) {
    allContacts(
      offset: $offset
      first: $first
      name: $name
      status: $status
      policyStatus: $policyStatus
      policyType: $policyType
      state: $state
      carrier: $carrier
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      birthMonth: $birthMonth
      ageFrom: $ageFrom
      ageTo: $ageTo
      turning65In3Months: $turning65In3Months
      age64NotApproaching65: $age64NotApproaching65
      tags: $tags
      gender: $gender
      preferredLanguage: $preferredLanguage
      immigrationStatus: $immigrationStatus
      zipCode: $zipCode
      isPolicyHolder: $isPolicyHolder
      withoutPolicy: $withoutPolicy
      withoutLead: $withoutLead
      myContacts: $myContacts
      isImportant: $isImportant
      user: $user
      assignedTo: $assignedTo
      signatureForm: $signatureForm
      hasSignedEntry: $hasSignedEntry
      effectiveDateAfter: $effectiveDateAfter
      effectiveDateBefore: $effectiveDateBefore
      policyCreatedFrom: $policyCreatedFrom
      policyCreatedTo: $policyCreatedTo
      submissionDateFrom: $submissionDateFrom
      submissionDateTo: $submissionDateTo
      completedDateFrom: $completedDateFrom
      completedDateTo: $completedDateTo
      lead: $lead
      isRecipient: $isRecipient
      segment: $segment
      organization: $organization
      effectiveYear: $effectiveYear
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          fullName
          firstName
          lastName
          email
          phone
          dateBirth
          created
          isImportant
          subscriptionStatus
          tagAssignments {
            tag {
              id
              name
              color
            }
          }
          memberPolicy {
            id
          }
          lead {
            id
          }
          members {
            edges {
              node {
                id
              }
            }
          }
          signatureEntries {
            edges {
              node {
                id
                requestedOn
                status
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ALL_RECIPIENTS = gql`
  query GetAllRecipients(
    $offset: Int
    $first: Int
    $name: String
    $status: String
    $policyStatus: String
    $policyType: String
    $state: String
    $carrier: String
    $policyCreatedFrom: Date
    $policyCreatedTo: Date
    $submissionDateFrom: Date
    $submissionDateTo: Date
    $completedDateFrom: Date
    $completedDateTo: Date
    $lead: String
    $segment: String
    $tags: String
    $effectiveYear: String
    $isPolicyHolder: Boolean
    $withoutPolicy: Boolean
    $ids: String
    $user: String
    $assignedTo: String
    $zipCode: String
    $immigrationStatus: String
    $gender: String
    $stateJurisdictionType: String
    $paymentStatus: String
    $documentStatus: String
    $metalLevel: String
    $leadSource: String
    $hasMemberId: Boolean
    $commissionPayable: Boolean
    $commissionPaymentStatus: String
    $unassigned: Boolean
    $ownsCar: Boolean
    $ownsHome: Boolean
    $hasAutoPolicy: Boolean
    $hasHomePolicy: Boolean
    $carrierStatusGeneric: String
    $carrierLastAsOfDateAfter: Date
    $carrierLastAsOfDateBefore: Date
    $carrierIsAgeIn: Boolean
    $carrierIsDelinquent: Boolean
    $carrierIsUnpaidPending: Boolean
    $carrierIsUnpaidPastDue: Boolean
  ) {
    allRecipients(
      offset: $offset
      first: $first
      name: $name
      status: $status
      policyStatus: $policyStatus
      policyType: $policyType
      state: $state
      carrier: $carrier
      policyCreatedFrom: $policyCreatedFrom
      policyCreatedTo: $policyCreatedTo
      submissionDateFrom: $submissionDateFrom
      submissionDateTo: $submissionDateTo
      completedDateFrom: $completedDateFrom
      completedDateTo: $completedDateTo
      lead: $lead
      segment: $segment
      tags: $tags
      effectiveYear: $effectiveYear
      isPolicyHolder: $isPolicyHolder
      withoutPolicy: $withoutPolicy
      ids: $ids
      user: $user
      assignedTo: $assignedTo
      zipCode: $zipCode
      immigrationStatus: $immigrationStatus
      gender: $gender
      stateJurisdictionType: $stateJurisdictionType
      paymentStatus: $paymentStatus
      documentStatus: $documentStatus
      metalLevel: $metalLevel
      leadSource: $leadSource
      hasMemberId: $hasMemberId
      commissionPayable: $commissionPayable
      commissionPaymentStatus: $commissionPaymentStatus
      unassigned: $unassigned
      ownsCar: $ownsCar
      ownsHome: $ownsHome
      hasAutoPolicy: $hasAutoPolicy
      hasHomePolicy: $hasHomePolicy
      carrierStatusGeneric: $carrierStatusGeneric
      carrierLastAsOfDateAfter: $carrierLastAsOfDateAfter
      carrierLastAsOfDateBefore: $carrierLastAsOfDateBefore
      carrierIsAgeIn: $carrierIsAgeIn
      carrierIsDelinquent: $carrierIsDelinquent
      carrierIsUnpaidPending: $carrierIsUnpaidPending
      carrierIsUnpaidPastDue: $carrierIsUnpaidPastDue
    ) {
      totalCount
      pageInfo {
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          fullName
          firstName
          lastName
          email
          phone
          dateBirth
          created
          isImportant
          subscriptionStatus
          tagAssignments {
            tag {
              id
              name
              color
            }
          }
          memberPolicy {
            id
          }
          signatureEntries {
            edges {
              node {
                id
                signedOn
                requestedOn
                status
              }
            }
          }
        }
      }
    }
    recipientStats(status: $status, effectiveYear: $effectiveYear, tags: $tags, segment: $segment) {
      totalRecipients
      subscribedCount
      unsubscribedCount
    }
  }
`

export const GET_ONE_CONTACT_API = gql`
  query contactById($id: String!) {
    contactById(id: $id) {
      id
      fullName
      firstName
      lastName
      middleName
      secondLastName
      preferredLenguage
      dateBirth
      gender
      email
      phone
      address1
      address2
      city
      zipCode
      countyFips
      immigrationStatus
      annualIncome1
      annualIncome2
      annualIncome3
      isImportant
      stateEU {
        id
        name
      }
      memberPolicy {
        id
        rol
        firstName
        lastName
        phone
        relationship
        policy {
          id
          policyName
          status
          stateDocs
          paymentStatus
          type
          created
          effectiveDate
          completedDate
          applicants
          members
          memberId
          hasAutoPolicy
          hasHomePolicy
          agentOfRecord
          zipCode
          stateEU {
            id
            code
          }
          user {
            id
            firstName
            lastName
            email
            cellphone
            avatar
          }
          holderMember {
            id
            firstName
            lastName
            phone
            rol
            relationship
          }
          carrier {
            id
            name
          }
          typePolicy {
            id
            typePolicy
          }
          assignedTo {
            id
            firstName
            lastName
          }
        }
      }
      members {
        edges {
          node {
            id
            rol
            firstName
            lastName
            phone
            relationship
            policy {
              id
              policyName
              status
              stateDocs
              paymentStatus
              type
              created
              effectiveDate
              completedDate
              applicants
              members
              memberId
              hasAutoPolicy
              hasHomePolicy
              agentOfRecord
              zipCode
              stateEU {
                id
                code
              }
              user {
                id
                firstName
                lastName
                email
                cellphone
                avatar
              }
              holderMember {
                id
                firstName
                lastName
                phone
                rol
                relationship
              }
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              assignedTo {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
      user {
        id
        firstName
        lastName
      }
      created
      updated
    }
  }
`

export const GET_ALL_CONTACTS_PREVIEW = gql`
  query allContactsPreview($name: String) {
    allContactsPreview(name: $name) {
      edges {
        node {
          id
          fullName
          firstName
          middleName
          lastName
          secondLastName
          preferredLenguage
          phone
          dateBirth
          gender
          email
          address1
          address2
          city
          zipCode
          immigrationStatus
          lead {
            id
            name
          }
          stateEU {
            id
            name
          }
          memberPolicy {
            id
            rol
            policy {
              id
              status
              paymentStatus
              type
              policyName
              created
              completedDate
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              user {
                id
                firstName
                lastName
              }
              assignedTo {
                id
                firstName
                lastName
              }
              effectiveDate
              archivedDate
              isArchived
            }
          }
          members {
            edges {
              node {
                id
                rol
                policy {
                  id
                  status
                  paymentStatus
                  type
                  policyName
                  created
                  completedDate
                  carrier {
                    id
                    name
                  }
                  typePolicy {
                    id
                    typePolicy
                  }
                  user {
                    id
                    firstName
                    lastName
                  }
                  assignedTo {
                    id
                    firstName
                    lastName
                  }
                  effectiveDate
                  archivedDate
                  isArchived
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_ALL_CONTACTS_POLICY_HOLDER_SEARCH = gql`
  query SearchPolicyHolderContacts($name: String, $first: Int) {
    allContacts(name: $name, first: $first) {
      edges {
        node {
          id
          fullName
          firstName
          middleName
          lastName
          secondLastName
          preferredLenguage
          phone
          dateBirth
          gender
          email
          address1
          address2
          city
          zipCode
          immigrationStatus
          stateEU {
            id
            name
          }
          memberPolicy {
            id
            rol
            policy {
              id
              status
              paymentStatus
              type
              policyName
              created
              completedDate
              carrier {
                id
                name
              }
              typePolicy {
                id
                typePolicy
              }
              user {
                id
                firstName
                lastName
              }
              assignedTo {
                id
                firstName
                lastName
              }
              effectiveDate
              archivedDate
              isArchived
            }
          }
          members {
            edges {
              node {
                id
                rol
                policy {
                  id
                  status
                  paymentStatus
                  type
                  policyName
                  created
                  completedDate
                  carrier {
                    id
                    name
                  }
                  typePolicy {
                    id
                    typePolicy
                  }
                  user {
                    id
                    firstName
                    lastName
                  }
                  assignedTo {
                    id
                    firstName
                    lastName
                  }
                  effectiveDate
                  archivedDate
                  isArchived
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_CONTACT_COMMUNICATION_LOGS = gql`
  query allCommunications($originModule: String, $originId: String, $contactId: String) {
    allCommunications(
      first: 50
      originModule: $originModule
      originId: $originId
      contact: $contactId
    ) {
      edges {
        node {
          id
          channel
          direction
          status
          content
          metadata
          created
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`
